import * as React from 'react';
import Head from 'next/head';
import { DefaultPageProps } from 'types';
import {
  defaultGetStaticPaths,
  defaultGetStaticProps,
  StaticPageParam
} from 'utils/staticPropsHelper';
import { getLegalBySlug, getLegalSlugs } from 'utils/contentful/legal';
import { Legal } from 'model/contentful/legal';
import LegalContainer from 'containers/Legal';
import { getHeaderTitle } from 'utils/string';
import { noIndex } from 'utils/SSR/hidePageOnProduction';

type ReferralCodePageProps = DefaultPageProps & {
  legalData: Legal;
};

const ReferralCodePage: React.FC<ReferralCodePageProps> = ({ legalData }) => {
  return (
    <div className="LegalPage w-full">
      <Head>
        <title>{getHeaderTitle(legalData.title)}</title>
        {noIndex()}
      </Head>
      <LegalContainer legalData={legalData} />
    </div>
  );
};

export const getStaticProps = async (context: any) => {
  const { params, preview } = context;
  const { props } = await defaultGetStaticProps(context);
  let legalData;

  try {
    legalData = await getLegalBySlug(params.slug, preview, props.lang);
    if (!legalData) {
      return {
        notFound: true
      };
    }
  } catch (e: any) {
    const error = JSON.parse(e);
    if (error.status === 404) {
      return {
        notFound: true
      };
    }
    console.error('Error fetching legal data: ', e);
  }

  return {
    props: {
      ...props,
      legalData: legalData || null
    },
    revalidate: 10
  };
};

export const getStaticPaths = async () => {
  const defaultPaths = defaultGetStaticPaths();
  let legalSlugs = [];

  try {
    legalSlugs = await getLegalSlugs();
  } catch (e) {
    console.error('Failed to get legal slugs: ', JSON.stringify(e));
  }

  const paths: Array<StaticPageParam> = [];
  defaultPaths.paths.forEach(path => {
    return legalSlugs.forEach(({ slug }: { slug: string }) => {
      paths.push({
        ...path,
        params: {
          ...path.params,
          slug
        }
      });
    });
  });

  return {
    paths,
    fallback: 'blocking'
  };
};

export default ReferralCodePage;
